import React from 'react';
import GradientSpinner from './GradientSpinner';
import '../App.css';

/** Inline loading for dashboard tab panels. */
const DashboardSectionLoader = ({ minHeight = 200 }) => (
  <div
    className="dashboard-section-loader"
    style={{ minHeight }}
  >
    <GradientSpinner size={56} />
  </div>
);

export default DashboardSectionLoader;
